import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "news-dune-three",
    title: "《沙丘2》全球票房突破7亿美元，第三部正式立项",
    summary: "维伦纽瓦的科幻史诗《沙丘2》全球票房持续走高，官方确认《沙丘3》已进入前期筹备，将改编自原著《沙丘救世主》。",
    date: "2026-10-12",
    category: "电影",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20vast%20orange%20desert%20dunes%20at%20sunset%20under%20a%20dramatic%20sky%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-dune&orientation=landscape",
    content: [
      "据最新票房数据显示，由丹尼斯·维伦纽瓦执导的科幻史诗《沙丘2》全球累计票房已正式突破7亿美元大关，成为近两年最具影响力的院线作品之一。",
      "在票房与口碑双丰收之后，制片方正式确认《沙丘3》已经立项，剧本将聚焦原著小说《沙丘救世主》中保罗·厄崔迪成为皇帝之后的命运纠葛。",
      "维伦纽瓦在采访中表示，第三部将是一部“完全不同气质”的电影，故事的规模会更大，但人物的内心世界也会更加幽深。",
      "业内普遍认为，随着这一系列持续升温，科幻大银幕的叙事标准正在被重新定义。",
    ],
    tags: ["沙丘", "票房", "科幻"],
  },
  {
    id: "news-oscar-nominations",
    title: "新一届奥斯卡提名公布，《奥本海默》领跑多项大奖",
    summary: "本届奥斯卡提名名单出炉，《奥本海默》以多项提名领跑，多部流媒体作品表现亮眼，华语与日韩作品同样受到关注。",
    date: "2026-10-10",
    category: "行业",
    cover: "https://readdy.ai/api/search-image?query=elegant%20golden%20award%20statuette%20silhouette%20against%20a%20dark%20stage%20with%20warm%20spotlights%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-oscar&orientation=landscape",
    content: [
      "新一届奥斯卡金像奖提名名单正式公布，多部年度佳作展开激烈角逐。其中，克里斯托弗·诺兰执导的《奥本海默》以多项提名领跑。",
      "本届提名名单中，流媒体平台出品的作品数量再创新高，显示出行业格局的持续变化。",
      "值得关注的是，日韩地区多部作品也成功入围技术类与外语片奖项，亚洲影视的全球影响力进一步增强。",
      "完整的获奖名单将在颁奖典礼当晚揭晓，业内已开始对本届热门影片展开广泛讨论。",
    ],
    tags: ["奥斯卡", "颁奖季", "行业"],
  },
  {
    id: "news-squid-game-s2",
    title: "《鱿鱼游戏》第二季创下流媒体收视新纪录",
    summary: "时隔三年回归的《鱿鱼游戏》第二季上线首周便刷新平台观看时长纪录，全球多地登上热度榜首。",
    date: "2026-10-08",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=surreal%20colorful%20playground%20with%20giant%20pastel%20pink%20and%20mint%20green%20staircases%2C%20ominous%20cinematic%20mood%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-squid&orientation=landscape",
    content: [
      "备受期待的《鱿鱼游戏》第二季正式上线后，首周便创下平台历史级的观看时长纪录，在多个国家和地区登上热度榜首位。",
      "第二季延续了第一季对人性与生存的探讨，同时引入了更多新的游戏设定与角色视角。",
      "主创黄东赫表示，第二季希望在保留紧张感的同时，进一步挖掘角色背后的动机与创伤。",
      "随着剧集热度持续攀升，围绕其社会寓意的讨论也再次成为全球媒体关注的焦点。",
    ],
    tags: ["鱿鱼游戏", "流媒体", "收视"],
  },
  {
    id: "news-the-glory-team",
    title: "《黑暗荣耀》主创新剧官宣，复仇题材再度升级",
    summary: "《黑暗荣耀》编剧与导演团队确认合作新剧，继续聚焦复仇与救赎主题，主演阵容引发广泛猜测。",
    date: "2026-10-05",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=moody%20winter%20city%20street%20at%20dusk%20with%20soft%20falling%20snow%20and%20warm%20street%20lights%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-glory&orientation=landscape",
    content: [
      "凭借《黑暗荣耀》获得广泛赞誉的编剧团队，近日正式官宣了他们的全新剧集计划，题材依旧围绕复仇与救赎展开。",
      "据透露，新剧将采用不同的叙事结构，通过多线并行的方式呈现一场更加复杂的算计与反击。",
      "虽然主演阵容尚未完全公开，但已有消息称将有多位实力派演员加盟，引发观众的强烈期待。",
      "制作方表示，新剧预计将在明年进入拍摄阶段。",
    ],
    tags: ["黑暗荣耀", "复仇", "新剧"],
  },
  {
    id: "news-brush-up-life",
    title: "日剧《重启人生》口碑持续走高，编剧揭秘创作幕后",
    summary: "《重启人生》凭借细腻的生活质感与温暖的友情叙事赢得大量好评，编剧在访谈中分享了创作灵感来源。",
    date: "2026-10-03",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=bright%20cheerful%20japanese%20suburban%20neighborhood%20with%20cherry%20blossoms%20and%20clear%20blue%20sky%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-brushup&orientation=landscape",
    content: [
      "近期上线的日剧《重启人生》凭借轻松幽默又饱含深情的叙事风格，收获了极高口碑，被不少观众称为“年度最治愈日剧”。",
      "编剧在访谈中透露，故事的灵感来源于对“如果人生可以重来”这一永恒命题的思考，希望用平凡人的日常打动人心。",
      "剧中对友情与选择的细腻刻画，成为观众讨论最多的话题之一。",
      "随着口碑持续发酵，该剧的相关话题在社交平台上长时间保持高热度。",
    ],
    tags: ["重启人生", "日剧", "口碑"],
  },
  {
    id: "news-marvel-slate",
    title: "漫威公布未来三年片单，多元宇宙进入全新阶段",
    summary: "漫威影业在发布会上公布了未来三年的电影与剧集计划，多元宇宙叙事将迎来关键转折点。",
    date: "2026-09-30",
    category: "行业",
    cover: "https://readdy.ai/api/search-image?query=stylized%20comic%20book%20style%20abstract%20background%20with%20dramatic%20color%20splashes%20and%20dynamic%20energy%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-marvel&orientation=landscape",
    content: [
      "漫威影业在最新发布会上公布了未来三年的完整片单，涵盖多部院线电影与流媒体剧集。",
      "官方表示，多元宇宙的叙事将进入一个全新的阶段，多条故事线会逐渐汇聚。",
      "此外，多位经典角色的回归计划也被正式确认，令全球粉丝倍感期待。",
      "业内分析认为，这一轮布局将决定超级英雄题材在未来数年的走向。",
    ],
    tags: ["漫威", "片单", "超级英雄"],
  },
  {
    id: "news-better-call-saul-star",
    title: "《风骚律师》主演确认加盟新喜剧，转型之作备受期待",
    summary: "凭借《风骚律师》深入人心的主演确认出演一部全新喜剧，将挑战与以往截然不同的角色类型。",
    date: "2026-09-27",
    category: "电影",
    cover: "https://readdy.ai/api/search-image?query=sun%20bleached%20desert%20highway%20with%20distant%20mesas%20under%20a%20vast%20blue%20sky%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-saul&orientation=landscape",
    content: [
      "以《风骚律师》中复杂角色塑造而广受好评的主演，近日确认加盟一部全新喜剧电影。",
      "据片方透露，这部作品将与其以往的严肃形象形成鲜明反差，展现其难得的喜剧天赋。",
      "影片预计将在明年春季开拍，目前正在紧锣密鼓地筹备中。",
      "许多观众表示，非常期待看到这位实力派演员的转型之作。",
    ],
    tags: ["风骚律师", "喜剧", "选角"],
  },
  {
    id: "news-parasite-anniversary",
    title: "《寄生虫》上映多年仍被热议，导演奉俊昊谈新作方向",
    summary: "《寄生虫》的影响力历久弥新，导演奉俊昊在近期采访中谈及了对社会题材的持续关注与未来计划。",
    date: "2026-09-24",
    category: "电影",
    cover: "https://readdy.ai/api/search-image?query=minimalist%20modern%20affluent%20house%20with%20large%20glass%20windows%20and%20manicured%20garden%2C%20cold%20clean%20lighting%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-parasite&orientation=landscape",
    content: [
      "距离《寄生虫》斩获金棕榈已过去多年，这部作品至今仍被全球影迷反复讨论。",
      "导演奉俊昊在近期采访中表示，他依然关注社会结构中的矛盾与张力，并会继续以此为创作的核心动力。",
      "关于新作，他透露正在同时推进多个项目，希望在题材与形式上都有新的尝试。",
      "影迷们普遍认为，这部经典之作对亚洲电影国际化的意义仍在持续显现。",
    ],
    tags: ["寄生虫", "奉俊昊", "韩国电影"],
  },
  {
    id: "news-hotd-season3",
    title: "《龙之家族》第三季正式开机，预计2026年回归",
    summary: "HBO奇幻巨制《龙之家族》第三季已正式开机，“巨龙之舞”将继续升级，拍摄规模创系列新高。",
    date: "2026-09-20",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20fantasy%20castle%20with%20dragons%20circling%20above%20a%20fiery%20crimson%20sky%2C%20epic%20cinematic%20mood%2C%20editorial%20news%20image%20style%2C%20high%20detail&width=1200&height=700&seq=news-hotd&orientation=landscape",
    content: [
      "HBO正式宣布，《龙之家族》第三季已经开机拍摄，这一奇幻系列将继续讲述坦格利安家族内战的激烈篇章。",
      "制作方表示，第三季的战争场面与特效规模都将创下系列新高，多条剧情线将进一步交汇。",
      "剧集预计将在2026年内与观众见面，具体档期将在后续公布。",
      "随着开机消息公布，相关话题迅速登上社交平台热搜，足见这一系列的超高人气。",
    ],
    tags: ["龙之家族", "HBO", "奇幻"],
  },
];